export const GET_PROJECT_LOADING = "PROJECT_loading";
export const GET_PROJECT_SUCCESS = "PROJECT_success";
export const GET_PROJECT_FAILED = "PROJECT_failed";
